<template>

    <div class="booking-view">

        <loading-state v-if="isLoading" fullscreen />

        <nav id="nav" class="navbar navbar-toggleable-sm">
            <div class="container">
        <span class="navbar-brand">
          <img
              v-if="carrierDetails"
              :src="`https://wefix-files.s3.eu-west-2.amazonaws.com/images/logos/${carrierDetails.name}/${carrierDetails.logoPath}.svg`"
              class="logo" :alt="`${carrierDetails.formattedName}`">
        </span>
                <h2 class="progress-container">Doorstep payment</h2>
            </div>
        </nav>

        <div v-if="!isLoading" class="content-container">
            <div class="content h-auto">
                <div class="container">
                    <div class="row">
                        <div class="col-12">

                            <!-- Repair Device Card -->
                            <div class="card">
                                <div class="card-body">
                                    <div class="basket-item card card-body card-body-sm">
                                        <div class="media">
                                            <p>
                                                In order for our technician to begin repairing your device you need to pay the following amount:
                                            </p>
                                        </div>

                                        <div class="media">
                                            <div class="media-left d-none d-md-block">
                                                <img :src="cart.device.image_path" alt="Device Image" class="img-2x" />
                                            </div>

                                            <div class="media-body">
                                                <h5>{{ cart.device.title }}</h5>

                                                <!-- Repair line items -->
                                                <div class="price-table table">
                                                    <div class="pricing-container">
                                                        <div v-for="(item, i) in cart.problems_pricing" :key="`item-${i}`">
                                                            <div class="tr">
                                                                <div class="td">
                                                                    {{ item.problem.title }}
                                                                </div>
                                                                <div class="td">
                                                                    £{{ item.price.toFixed(2) }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Repair Payment Card -->

                            <div class="card-list position-relative h-auto">
                                <template v-if="klarnaInstalled">
                                    <klarna-payment-method/>
                                    <klarna-instalments-payment-method />
                                </template>
                                <drop-in-3d-secure v-if="carrierDetails.use3DSecure" :is-selected="true"/>
                                <drop-in v-if="!carrierDetails.use3DSecure" :is-selected="true"/>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
/* global Klarna */
import {mapActions, mapGetters} from "vuex";

export default {
    name: 'DoorstepPayment',

    data() {
        return {
            paymentMethod: '',
            isLoading: true,
            order: null
        };
    },

    computed: {
        ...mapGetters([
            'booking',
            'carrier',
            'carrierDetails',
            'klarnaInstalled',
            'paymentMethodIsSelected'
        ]),

        cart() {
            return (this.booking)
                ? this.booking.cart.devices[Object.keys(this.booking.cart.devices)[0]]
                : null;
        }
    },

    methods: {
        ...mapActions([
            'setPaymentMethod',
            'retrieveBookingByRef',
            'generateBillingTokens',
            'setKlarnaSdkAsAvailable'
        ]),

        setupKlarna() {
            let self = this;
            let klarnaScript = document.createElement('script');

            klarnaScript.setAttribute('src', 'https://x.klarnacdn.net/kp/lib/v1/api.js');

            document.head.appendChild(klarnaScript);
            window.klarnaAsyncCallback = function () {
                Klarna.Payments.init({
                    client_token: self.klarnaClientToken
                });

                self.setKlarnaSdkAsAvailable();
            };
        },
    },

    async mounted() {
        const {order_ref} = this.$route.query;

        await this.retrieveBookingByRef(order_ref);

        if (!this.klarnaInstalled) {
            await this.setPaymentMethod("braintree");
        }

        await this.generateBillingTokens();

        if (this.klarnaInstalled) {
            this.$nextTick(() => {
                this.setupKlarna();
                this.isLoading = false;
            })
        } else {
            this.isLoading = false;
        }
    }
}
</script>